import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Store from './redux/';
import Routes from './routes';
import GlobalStyle from './styles/global';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <Routes />
      <GlobalStyle />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
